const IERegions = {
  countryCode: 'IE',
  regionLinks: [
    {
      title: 'Dublin',
    },
  ],
};

export default IERegions;
